import { apiClient, API_PRX } from '@indipia/shared';

export interface WorkType {
  workTypeId: number;
  workTypeCode: string;
  workTypeName: string;
  sortOrder: number;
}

export async function fetchWorkTypes(): Promise<WorkType[]> {
  const res = await apiClient.get(`${API_PRX.INDIPIA}/work-types`);
  return res.data.data as WorkType[];
}

export async function createPartner(payload: {
  partnerName: string;
  mobile: string;
  specialtyTypes?: string;
  partnerBizYn: string;
  commYn?: string;
  partnerBizNo?: string | null;
  partnerBizName?: string | null;
  partnerRepName?: string | null;
}): Promise<number> {
  const res = await apiClient.post(`${API_PRX.MEMBER}/partners`, payload);
  return res.data.data.partner_id as number;
}
